import settings from '../config/settings';
import axios from './axios';

const { apiBaseURL } = settings;

export default class BugReportApi {
  static getBugReports() {
    return axios.get(`${apiBaseURL}/bug-reports`);
  }

  static updateBugReport({ id, ...rest }) {
    return axios.patch(`${apiBaseURL}/bug-reports/${id}`, rest);
  }

  static postBugReport(data) {
    return axios.post(`${apiBaseURL}/bug-reports`, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/BugReportApi.js